<script>
    import utilsService from '@/services/core/utils.service';

    export default {
        props: {
            modelValue: null,
            options: Array,
            textKey: {
                type: String,
                default: 'name'
            },
            valueKey: {
                type: String,
                default: 'id'
            }
        },
        emits: ['update:modelValue', 'change'],
        data() {
            return {
                uuid: utilsService.uuid()
            };
        },
        methods: {
            onChange(e) {
                let value = e.target.value;

                if (utilsService.isNumber(value)) value = +value;
                else if (value === 'true' || value === 'false') value = value === 'true';

                this.$emit('update:modelValue', value);
                this.$emit('change', value);
            }
        }
    };
</script>

<template>
    <select class="form-select" :value="modelValue" @change="onChange">
        <option v-for="(lo, index) in options" :value="lo[valueKey]" :key="`${uuid}-${index}`">{{ lo[textKey] }}</option>
    </select>
</template>
